import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { GameId } from 'src/app/model/game/game-id';

@Component({
  selector: 'app-game-icon',
  templateUrl: './game-icon.component.html',
  styleUrls: ['./game-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameIconComponent implements OnInit, OnChanges {
  @Input({ required: true }) game!: GameId;
  @Input() background?: boolean = false;
  @Input() size = '--spacing-4x-large';

  private themeService = inject(ThemeService);
  src = '';
  gradientStyle = '';

  private readonly gradients: Record<string, string> = {
    solitaire: 'linear-gradient(135deg, var(--pink-500), var(--orange-500))',
    blocks: 'linear-gradient(135deg, var(--indigo-700), var(--blue-600))',
    blackjack: 'linear-gradient(135deg, var(--green-300), var(--green-800))',
  };

  get sizeCss(): string {
    return `var(${this.size})`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['game']) {
      this.updateIcon();
    }
  }

  ngOnInit(): void {
    this.src = `assets/images/${this.themeService.imagesFolder()}/${this.game}-icon.svg`;
    this.gradientStyle = this.background
      ? this.gradients[this.game] || 'linear-gradient(45deg, #CCCCCC, #AAAAAA)'
      : 'none';
  }

  private updateIcon(): void {
    this.src = `assets/images/${this.themeService.imagesFolder()}/${this.game}-icon.svg`;
    this.gradientStyle = this.background
      ? this.gradients[this.game] || 'linear-gradient(45deg, #CCCCCC, #AAAAAA)'
      : 'none';
  }
}
